import axios from 'axios'

const SCHEDA_API_URL = process.env.REACT_APP_NODE_ENV === 'production' ? process.env.REACT_APP_BASE_URL + '/api/schedaSpese/' : '/api/schedaSpese/'

// Upload + OCR a receipt/statement file for a scheda. Returns a best-effort
// parsed preview only - nothing is created yet, see confirmAttachment below.
const scanAttachment = async (schedaId, file, token) => {
  const formData = new FormData()
  formData.append('file', file)

  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      // No 'Content-Type' here - axios/the browser set the multipart
      // boundary automatically when the body is a FormData instance.
    },
  }

  const response = await axios.post(`${SCHEDA_API_URL}${schedaId}/attachments/scan`, formData, config)
  return response.data
}

// Turns the (possibly user-edited) parsed entries from a scan into real notaSpese.
const confirmAttachment = async (schedaId, attachmentId, entries, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  }

  const response = await axios.post(
    `${SCHEDA_API_URL}${schedaId}/attachments/${attachmentId}/confirm`,
    { entries },
    config
  )
  return response.data
}

const attachmentService = {
  scanAttachment,
  confirmAttachment,
}

export default attachmentService
